/* eslint-disable no-unused-vars */
import { useEffect, useMemo } from 'react';
import { Badge, Button } from 'react-bootstrap';
import { FaEye, FaRegEdit } from 'react-icons/fa';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { usePagination, useRowSelect, useTable, useFilters, useExpanded } from 'react-table';
import DefaultColumnFilter from '../../../../Components/ReactTable/Filters/DefaultColumnFilter';
import ReactTableRender from '../../../../Components/ReactTable/ReactTableRender';
import { clearTable, handleSuperUserListChange } from '../../../../Redux/slices/table';
import UserImage from '../../../../Components/UserImage';
import { Link } from 'react-router-dom';

function SuperAdminTable() {
  const dispatch = useDispatch();
  const pageNum = useSelector((state) => state.table.pageNum);
  const loading = useSelector((state) => state.table.loading);
  const totalCount = useSelector((state) => state.table.totalCount);
  const results = useSelector((state) => state.table.results);
  const activeRole = useSelector((state) => state.user?.user?.active_role);

  const columns = useMemo(
    () => [
      {
        Header: <FormattedMessage id="fullname" />,
        accessor: 'fullname',
        Cell: ({ row: { original }, cell: { value } }) => {
          return (
            <Link to={`profile/${original.id}`}>
              <span className="d-flex align-items-center ">
                <div className="me-1 position-relative">
                  <UserImage
                    avatar={original.image}
                    userName={value}
                    userId={String(original.id)}
                  />
                </div>

                <span className="d-block">
                  {value} <br />
                  {/* <small>({original.office_name})</small> */}
                </span>
                {original.suspended && <Badge bg="danger">Suspended</Badge>}
              </span>
            </Link>
          );
        }
      },
      {
        Header: <FormattedMessage id="office_type" />,
        accessor: 'office_type'
      },

      {
        Header: <FormattedMessage id="mobile_number" />,
        accessor: 'phone'
      },
      {
        Header: <FormattedMessage id="actions" />,
        accessor: 'actions',
        disableFilters: true,
        Cell: ({ row: { original } }) => (
          <div className="d-flex">
            <div>
              <Link to={`profile/${original.id}`}>
                <Button variant="outline-info">
                  <FaEye />
                </Button>
              </Link>
            </div>
            {activeRole === 'superuser' && (
              <>
                <div className="ms-2">
                  <Link to={`edit/${original.id}`}>
                    <Button variant="outline-success ">
                      <FaRegEdit />
                    </Button>
                  </Link>
                </div>
              </>
            )}
          </div>
        )
      }
    ],
    [activeRole]
  );

  const data = useMemo(() => {
    if (!results) return [];
    return results.map((result) => {
      return {
        fullname: result.fullname,
        office_type: 'PCU',
        phone: result.phone,
        id: result.id,
        suspended: result.suspended
      };
    });
  }, [results]);

  const defaultColumn = useMemo(
    () => ({
      // Let's set up our default Filter UI
      Filter: DefaultColumnFilter
    }),
    []
  );

  const {
    headerGroups,
    getTableProps,
    getTableBodyProps,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    visibleColumns,
    setPageSize,
    state: { pageSize, pageIndex }
  } = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: 0, pageSize: 50 },
      manualPagination: true,
      pageCount: pageNum,
      defaultCanFilter: false,
      defaultColumn
      // manualFilters: true
    },
    useExpanded,
    useFilters,
    usePagination,
    useRowSelect
  );
  const pageCountArray = useMemo(
    () => Array.from({ length: Math.ceil(totalCount / pageSize) }, (v, i) => i + 1),
    [totalCount]
  );

  useEffect(() => {
    dispatch(handleSuperUserListChange({ index: pageIndex, pageSize: pageSize }));
  }, [pageIndex, pageSize]);
  useEffect(() => {
    return () => {
      dispatch(clearTable());
    };
  }, []);
  return (
    <div>
      <ReactTableRender
        getTableProps={getTableProps}
        headerGroups={headerGroups}
        getTableBodyProps={getTableBodyProps}
        page={page}
        prepareRow={prepareRow}
        totalCount={totalCount}
        gotoPage={gotoPage}
        previousPage={previousPage}
        pageCount={pageCount}
        pagination={true}
        pageCountArray={pageCountArray}
        pageNum={pageNum}
        showGoto={true}
        nextPage={nextPage}
        pageIndex={pageIndex}
        canNextPage={canNextPage}
        canPreviousPage={canPreviousPage}
        loading={loading}
        visibleColumns={visibleColumns}
        pageSize={pageSize}
        setPageSize={setPageSize}
      />
    </div>
  );
}

export default SuperAdminTable;
